module.exports = __webpack_public_path__ + "header-logo-medium.41d6f234.png";